module.exports = __webpack_public_path__ + "img/jing4.445de099.jpg";